module.exports = __webpack_public_path__ + "img/Judges.49adaf82.png";